module.exports = __webpack_public_path__ + "files/aeea047bff1c93671613f6695ca70ea1.png";